export const WINDOW_CONTENT_HEIGHT = {
  LARG_SCREEN: 'calc(100vh - 72px - 48px)',
};
